<template>
    <div class="case-progress-page">
        <div class="text-right">
            <v-img src="@/assets/D_A_LOGO_trans.png" alt="" height="55px" contain class="d-inline-block" />
        </div>
        <v-container class="pt-6 pb-3 pr-6 pl-6 content-wrapper">
            <div class="d-flex justify-space-between align-start mb-8">
                <div>
                    <h2 class="text-h5 font-weight-bold" style="color: #0A1F44;">Case Progress</h2>
                    <p class="text-caption mt-2 mb-0" style="color: #13417E; letter-spacing: 0.2px;">
                        This page allows you to view the latest progress of your case.
                    </p>
                </div>
                <v-btn depressed class="btn-pdf-export px-5" @click="exportToPdf"
                    style="text-transform: none !important;">
                    <v-icon left size="18" class="mr-2">mdi-file-pdf-box</v-icon>
                    Export to PDF
                </v-btn>
            </div>
            <div class="content-case-progress mb-16">
                <!-- Case Summary -->
                <v-card class="pa-4 mb-6" rounded="lg">
                    <v-row>
                        <v-col cols="12" sm="6" md="5">
                            <v-row>
                                <v-col cols="12" md="12">

                                    <div class="d-flex align-start">

                                        <!-- icon -->
                                        <div class="icon-cass-no mr-5" :style="{ backgroundColor: '#E6EEF9' }">
                                            <v-icon color="#13417E" size="30">
                                                mdi-folder-open
                                            </v-icon>
                                        </div>

                                        <!-- text -->
                                        <div>
                                            <div class="font-weight-bold text-caption text-grey-color ">Case No.</div>
                                            <div class="font-weight-bold text-body-1">{{ caseInfo.caseNo }}</div>

                                            <div class="font-weight-bold text-grey-color text-caption  mt-3 ">
                                                Client</div>
                                            <div class="font-weight-bold text-body-2">{{ caseInfo.client }}</div>
                                        </div>

                                    </div>

                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="7">
                            <v-row>


                                <v-col cols="12" md="6">
                                    <div class="text-with-border">
                                        <div class="font-weight-bold text-grey-color text-caption text-grey">Case Type
                                        </div>
                                        <div class="font-weight-bold text-body-2">{{ caseInfo.caseType }}</div>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <div class="text-with-border mr-16">
                                        <div class="font-weight-bold text-grey-color text-caption ">Current Status</div>

                                        <v-chip color="#E6EEF9" class="custom-chip " label>
                                            {{ caseInfo.status ? caseInfo.status : 'Awaiting Update...' }}
                                        </v-chip>
                                    </div>
                                    <div class="text-with-border mt-3">
                                        <div class="text-caption font-weight-bold text-grey-color">Last Updated</div>
                                        <div class="font-weight-bold" style="font-size: 13px;">
                                            <v-icon class="calendar-icon " size="15"
                                                color="black">mdi-calendar-today</v-icon>
                                            {{ caseInfo.lastUpdated ? caseInfo.lastUpdated : 'Awaiting Update...' }}
                                        </div>
                                    </div>
                                </v-col>

                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>

                <!-- Latest Update -->
                <v-card class="pa-4 mb-6" rounded="lg">

                    <v-row>

                        <v-col cols="12" sm="8" md="8">
                            <div class="text-subtitle-1 font-weight-bold mb-2" style="color: #13417E;">
                                Latest Update
                            </div>
                            <div style="font-size: 13px;">
                                {{ latestUpdate.message ? latestUpdate.message : 'Awaiting Update...' }}
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="d-flex align-center">
                            <div class="d-flex align-start">
                                <div class="icon-date-time mr-5" :style="{ backgroundColor: '#E6EEF9' }">
                                    <v-icon color="#13417E" size="20">
                                        mdi-calendar-clock
                                    </v-icon>
                                </div>

                                <div>
                                    <div class="text-caption font-weight-bold text-grey-color">Last Updated:</div>
                                    <div class="font-weight-bold" style="font-size: 13px;"> {{ latestUpdate.date ?
                                        latestUpdate.date : 'Awaiting Update...' }}</div>

                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>

                <!-- Timeline -->
                <v-card class="pa-4 mb-6" rounded="lg" v-if="timelineData.length > 0">
                    <div class="text-subtitle-1 font-weight-bold mb-4" style="color: #13417E;">
                        Progress Timeline
                    </div>

                    <div class="timeline-wrapper">

                        <!-- เส้นกลางเส้นเดียว -->
                        <div class="timeline-main-line"></div>

                        <div v-for="(item, index) in timelineData" :key="index" class="timeline-row">
                            <!-- icon -->
                            <div class="timeline-left">
                                <div class="timeline-icon" :style="{
                                    backgroundColor:
                                        index === timelineData.length - 1
                                            ? 'transparent'
                                            : (
                                                ['#13417E', '#3385F0', '#80ABEA', '#E0E9F7', '#E6EEF9']
                                            )[Math.min(index, ['#13417E', '#3385F0', '#80ABEA', '#E0E9F7', '#E6EEF9'].length - 1)],
                                    border:
                                        index === timelineData.length - 1
                                            ? '2px solid #E6EEF9'
                                            : 'none'
                                }">
                                    <v-icon color="white" size="20" v-if="index < timelineData.length - 1">
                                        mdi-check
                                    </v-icon>
                                    <v-icon color="white" size="20" v-else>

                                    </v-icon>
                                </div>
                            </div>

                            <!-- card -->
                            <div class="timeline-card-wrapper">
                                <v-card flat class="timeline-card pa-4 mb-4" :style="{
                                    backgroundColor: index === 0 ? '#F1F6FA' : null,
                                    border: index !== 0 ? '1px solid #d1d5db' : 'none'
                                }">
                                    <div v-if="index === 0" class="timeline-arrow" :style="{
                                        backgroundColor: index === 0 ? '#F1F6FA' : null,
                                        border: index !== 0 ? '1px solid #d1d5db' : 'none'
                                    }"></div>

                                    <v-row>
                                        <v-col cols="12" sm="8" md="8">
                                            <p class="text-body-2  mb-1  text-grey-color">
                                                {{ item.status_time }}
                                            </p>
                                            <div class="d-flex align-center " style="margin-top: -6px;">
                                                <span class="font-weight-bold mr-2">
                                                    {{ item.status }}
                                                </span>
                                            </div>

                                            <p class="text-body-2 text-grey" style="margin-bottom: -8px;">
                                                {{ item.status_note }}
                                            </p>
                                        </v-col>

                                        <v-col cols="12" sm="4" md="4" class="text-right text-caption">
                                            <p style="color: #13417E;">{{ item.worker }}</p>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </v-card>
                <v-card class="pa-8 mb-6 d-flex flex-column align-center justify-center text-center" rounded="lg" v-else
                    min-height="220">
                    <v-icon size="60" color="#B0BEC5">
                        mdi-timeline-clock-outline
                    </v-icon>

                    <div class="text-h6 font-weight-bold mt-4" style="color: #13417E;">
                        Progress Timeline
                    </div>

                    <div class="text-body-2 mt-2" style="color: #78909C; max-width: 400px;">
                        Your progress timeline is currently being prepared.
                        Please check back again later.
                    </div>
                </v-card>

                <!-- alerty -->
                <v-card class="pa-4" rounded="lg" :style="{ backgroundColor: '#FFF9EB', border: '1px solid #FAEABA' }">

                    <div class="d-flex align-center">
                        <div class="icon-informations mr-5" :style="{ backgroundColor: '#FAEABA' }">
                            <v-icon color="#DAA30B" size="32">
                                mdi-information
                            </v-icon>
                        </div>

                        <div>
                            <div class="font-weight-bold text-body-2 mb-1">This page is for viewing progress only</div>
                            <div style="font-size: 14px;">If you have questions, plaese contact our team directly by
                                email.</div>

                        </div>
                    </div>

                </v-card>
            </div>
            <div class="text-center">
                <p class="text-caption text-grey-1 mt-3" style="color: #13417E;">
                    Powered by Dtime • © {{ currenyear }} Digital Corporate Management Co.,Ltd. All rights reserved.
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
import { server } from "@/services/constants";
import api from "@/services/api";
import Hashids from "hashids";
import unity from "@/unity/unity";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";

import moment from "moment";
export default {
    name: "ClientTimeLine",

    data() {
        return {
            main_id: "",
            currenyear: new Date().getFullYear(),
            caseInfo: {
                // caseNo: "CAS-2026-0012",
                // client: "ABC Trading Sdn. Bhd.",
                // caseType: "Company Registration",
                // status: "In Progress",
                // lastUpdated: "14 May 2026, 10:30 AM",
            },

            latestUpdate: {
                // message:
                //     "We have reviewed the submitted documents and are currently preparing the draft for internal review.",
                // date: "14 May 2026, 10:30 AM",
            },

            timelineData: [
                // {
                //     status: "In Progress",
                //     status_time: "15/05/2026 09:30 AM",
                //     status_note: "Work on this request has started and is currently being processed by the assigned team.",
                //     worker: "John Doe"
                // },

            ]
        };
    },

    async mounted() {
        await this.initPage();
        this.$hideLoader();
    },
    methods: {
        async initPage() {
            this.$showLoader();

            const encodedId = this.$route.params.id;

            const hashids = new Hashids("my-secret-salt", 8);

            const decoded = hashids.decode(encodedId);

            this.main_id = decoded[0];

            await this.loaddataMainCase();
            await this.loaddataTimelineVisibility();
        },
        async loaddataMainCase() {


            const resultappointment = await api.getgetTimelineDataDetail({
                params: {
                    module_name: this.$route.query.module_name,
                    case_id: Number(this.main_id),
                }
            })

            if (resultappointment.data && resultappointment.data.length > 0) {

                this.caseInfo = resultappointment.data[0];
            }


        },
        async loaddataTimelineVisibility() {
            const result_timeline_visibility = await api.getgetClientTimelineHistoryShowVisibility({
                params: {
                    module_name: this.$route.query.module_name,
                    case_id: Number(this.main_id),
                }
            })
            if (result_timeline_visibility.data && result_timeline_visibility.data.length > 0) {
                this.timelineData = result_timeline_visibility.data;

                this.latestUpdate.message = result_timeline_visibility.data[0].status_note;
                this.latestUpdate.date = result_timeline_visibility.data[0].status_time;

                this.caseInfo.status = result_timeline_visibility.data[0].status;
                this.caseInfo.lastUpdated = result_timeline_visibility.data[0].status_time;
            }

        },
        exportToPdf() {
            const data = {
                caseInfo: this.caseInfo,
                latestUpdate: this.latestUpdate,
                timelineData: this.timelineData,
            };

            // ตัวนี้จะวิ่งไปเรียกโค้ดใหม่ที่เราปรับปรุงในขั้นตอนที่ 2 อัตโนมัติ
            PDFCaseProgress.exportToPDF(data);
        }
    }
};
</script>

<style scoped>
.case-progress-page {
    background: #FFFFFF;
    min-height: 100vh;
    padding-top: 40px;
}

.content-wrapper {
    max-width: 800px !important;
    margin: 0 auto;
}

.content-case-progress {
    background: #FBFBFB;
    padding: 15px;
}

.icon-cass-no {
    min-width: 60px;
    min-height: 60px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

.icon-date-time {
    min-width: 40px;
    min-height: 40px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

.icon-informations {
    min-width: 50px;
    min-height: 50px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.text-with-border {
    display: inline-block;
    padding-left: 20px;
    border-left: 1px solid #D0D5DD;
}

.custom-chip {
    border-radius: 20px !important;
    font-size: 12px !important;
    font-weight: 600;
    padding: 0 12px !important;
    height: 22px !important;
    color: #0953E5 !important;
}

/* wrapper */
.timeline-wrapper {
    position: relative;
}

/* เส้นกลางเส้นเดียว */
.timeline-main-line {
    position: absolute;
    top: 20px;
    /* เริ่มใต้ icon ตัวแรก */
    bottom: 90px;
    /* จบเหนือ icon ตัวสุดท้าย */
    left: 34px;
    /* กลาง icon */
    width: 2px;
    background: #d1d5db;
    z-index: 1;
}

/* row */
.timeline-row {
    display: flex;
    align-items: flex-start;
    position: relative;
}

/* left */
.timeline-left {
    width: 70px;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 2;
    margin-top: 17px;
}

/* icon */
.timeline-icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

/* right */
.timeline-card-wrapper {
    flex: 1;
    position: relative;
}

/* card */
.timeline-card {
    position: relative;
    margin-left: 14px;
    overflow: visible !important;
    border-radius: 12px;
}

/* arrow */
.timeline-arrow {
    position: absolute;
    top: 30px;
    left: -4px;

    width: 12px;
    height: 12px;

    background: inherit;
    /* ใช้สีเดียวกับ card */
    transform: rotate(45deg);

    border-radius: 1px;
    /* ทำให้มุมมน */
    z-index: 1;
}

.status-summary-icon {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0 4px white;
}

.title-line {
    display: flex;
    align-items: center;
    gap: 10px;
}

.title-line::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e0e0e0;
}

.text-grey-color {
    color: #7b7a7a;
}

.text-grey {
    color: #6b7280;
}

@media (max-width: 599px) {
    .timeline-main-line {
        bottom: 150px;
        /* เปลี่ยนเป็นค่าที่ต้องการ */
    }
}

@media (max-width: 465px) {
    .timeline-main-line {
        bottom: 150px;
        /* เปลี่ยนเป็นค่าที่ต้องการ */
    }
}

@media (max-width: 410px) {
    .timeline-main-line {
        bottom: 150px;
        /* เปลี่ยนเป็นค่าที่ต้องการ */
    }
}
</style>